export function hasPermission(user, modelName, permissionName) {
    if (!user || !user.permissions) return false;
    
    return user.permissions.some(permission => 
      permission.permissions.models.name === modelName &&
      permission.permissions.name === permissionName
    );
  }